import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { properties } from './properties.js';
import { withTranslation } from 'react-i18next';
import { apiPublicRequest, apiSecuredRequest} from './functions.js';
import i18n from './I18N/I18n.js'; 
import LogInNavBar from './LogInNavBar.js';
import NavBar from './navbar.js';
import Footer from './footer.js';
import Cookies from 'js-cookie';
import './css/changePassword.css'; // Importa el CSS del componente

class ChangePassword extends Component {
  async componentDidMount() {
     this.loadUserMail();
  }

  cambiarIdioma = (idioma) => {
          const { i18n } = this.props;
          i18n.changeLanguage(idioma);
          Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Guarda la preferencia por un año // Cambia el idioma usando i18n
      };

  logout = async () => {
    this.setState({bearer: null});
    this.setState({email: null});
    logout();
  }

  async loadUserMail() {
    const email = Cookies.get("email");
    this.setState({ email: email });
    const bearer = Cookies.get("id");
    this.setState({ bearer: bearer });
    const firstLogin = localStorage.getItem('firstLogin');
    this.setState({ firstLogin, email, bearer });
  }

  _changePass = async (password, newPass, newPassRepeat) => {
    if (newPass !== newPassRepeat) {
      this.setState({ newPassNotMatch: true });
    } else {
      this.setState({ newPassNotMatch: false });
      let data = JSON.stringify({
        "email": this.state.email,
        "password": password
      });
      const firstLogin = localStorage.getItem('firstLogin');
      try {
        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/empresas/login`, data);

        if (bearerToken.status === 200) {
          const token = bearerToken.data;
          let userMail = JSON.stringify({
            "email": this.state.email
          });
          const userInfo = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUser`, userMail, bearerToken.data.accessToken);

          const loggedUserInfo = userInfo.data;
          let updateData;

          if(firstLogin == 'true') {

            updateData = JSON.stringify({
              "password": newPass,
              "email": loggedUserInfo.email,
              "nombre": loggedUserInfo.nombre,
              "apellido1": loggedUserInfo.apellido1,
              "apellido2": loggedUserInfo.apellido2,
              "activeUser": true,
              "walletDir": loggedUserInfo.walletDir,
              "documento": loggedUserInfo.documento,
              "termsAndConditions": false,
              "proofUWallet": loggedUserInfo.proofUWallet,
              "userRol": {
                "id": "4",
                "rol": "EMPRESA"
              }
            });

          }else{
            updateData = JSON.stringify({
              "password": newPass,
              "email": loggedUserInfo.email,
              "nombre": loggedUserInfo.nombre,
              "apellido1": loggedUserInfo.apellido1,
              "apellido2": loggedUserInfo.apellido2,
              "activeUser": true,
              "walletDir": loggedUserInfo.walletDir,
              "documento": loggedUserInfo.documento,
              "termsAndConditions": loggedUserInfo.termsAndConditions,
              "proofUWallet": loggedUserInfo.proofUWallet,
              "userRol": {
                "id": "4",
                "rol": "EMPRESA"
              }
            });
          }

          const response = await apiSecuredRequest('put', `${properties.apiUrl}/certificat/api/usuario/update/${loggedUserInfo.id}`, updateData, bearerToken.data.accessToken);

          
          Swal.fire({
            title: `${i18n.t('passwordChanged')}`,
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Finish'
          }).then((result) => {
            if (result.isConfirmed) {
              if (this.state.firstLogin === "true") {
                localStorage.setItem('newPass', newPass);
                localStorage.removeItem('firstLogin');
                localStorage.setItem("pendingSign", "true");
                window.location.href = `/terminosYcondiciones`;
              } else {
                window.location.href = `/listaEmpresas`;
              }
            }
          });
        }else{
          Swal.fire({
            title: `${i18n.t('incorrectPassword')}`,
            confirmButtonText: `${i18n.t('continue')}`,
            confirmButtonColor: '#E94981',
            icon: 'info',
            iconColor: '#66C08B',
            width: '560px',
        });
        }
      } catch (err) {
        this.setState({ incorrectUser: true });
        Swal.fire({
          title: `${i18n.t('errorOccurred')}`,
          confirmButtonText: `${i18n.t('continue')}`,
          confirmButtonColor: '#E94981',
          icon: 'info',
          iconColor: '#66C08B',
          width: '560px',
      });
        
      }
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      bearer: "",
      email: "",
      newPassNotMatch: false,
      incorrectUser: false,
      firstLogin: null
    };
  }

  render() {
    if (this.state.firstLogin === "true") {
      return (
        <>
          <div className="password-reset-container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                const oldPass = this.oldPass.value;
                const newPass = this.newPass.value;
                const newPassRepeat = this.newPassRepeat.value;
                this._changePass(oldPass, newPass, newPassRepeat);
              }}
              className="password-reset-form"
            >
              <LogInNavBar cambiarIdioma={this.cambiarIdioma} />
              <h1 className="password-reset-title"> {i18n.t('changePass')}</h1>
              <p className="password-reset-description">
                {i18n.t('useSame')}
              </p>
  
              <h1
                className={this.state.newPassNotMatch ? "password-reset-error" : ""}
              >
                {this.state.newPassNotMatch ? "New Password does not match" : ""}
              </h1>
  
              <div className="password-reset-group">
                <label
                  htmlFor="old_password"
                  className="password-reset-label"
                >
                  {i18n.t('oldPass')}
                </label>
                <input
                  required
                  type="password"
                  id="old_password"
                  ref={(oldPass) => (this.oldPass = oldPass)}
                  className="password-reset-input"
                />
              </div>
  
              <div className="password-reset-group">
                <label
                  htmlFor="new_password"
                  className="password-reset-label"
                >
                  {i18n.t('newPass')}
                </label>
                <input
                  required
                  type="password"
                  id="new_password"
                  ref={(newPass) => (this.newPass = newPass)}
                  className="password-reset-input"
                />
              </div>
  
              <div className="password-reset-group">
                <label
                  htmlFor="new_password_repeat"
                  className="password-reset-label"
                >
                  {i18n.t('repeatPass')}
                </label>
                <input
                  required
                  type="password"
                  id="new_password_repeat"
                  ref={(newPassRepeat) => (this.newPassRepeat = newPassRepeat)}
                  className="password-reset-input"
                />
              </div>
  
              <button type="submit" className="password-reset-btn">
                {i18n.t('confirm')}
              </button>
              <p>
                <a
                  href="mailto:juan.ayensa@certifica-t.ap?subject=Support of Certifica-t (Change Password Problems)"
                  className="password-reset-link"
                >
                </a>
              </p>
            </form>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="password-reset-container">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                const oldPass = this.oldPass.value;
                const newPass = this.newPass.value;
                const newPassRepeat = this.newPassRepeat.value;
                this._changePass(oldPass, newPass, newPassRepeat);
              }}
              className="password-reset-form"
            >
              <NavBar
                mail={this.state.email}
                bearer={this.state.bearer}
                logout={this.logout}
                cambiarIdioma={this.cambiarIdioma}
              />
              <h1 className="password-reset-title"> {i18n.t('changePass')}</h1>
              <p className="password-reset-description">
                {i18n.t('useSame')}
              </p>
  
              <h1
                className={this.state.newPassNotMatch ? "password-reset-error" : ""}
              >
                {this.state.newPassNotMatch ? "New Password does not match" : ""}
              </h1>
  
              <div className="password-reset-group">
                <label
                  htmlFor="old_password"
                  className="password-reset-label"
                >
                  {i18n.t('oldPass')}
                </label>
                <input
                  required
                  type="password"
                  id="old_password"
                  ref={(oldPass) => (this.oldPass = oldPass)}
                  className="password-reset-input"
                />
              </div>
  
              <div className="password-reset-group">
                <label
                  htmlFor="new_password"
                  className="password-reset-label"
                >
                  {i18n.t('newPass')}
                </label>
                <input
                  required
                  type="password"
                  id="new_password"
                  ref={(newPass) => (this.newPass = newPass)}
                  className="password-reset-input"
                />
              </div>
  
              <div className="password-reset-group">
                <label
                  htmlFor="new_password_repeat"
                  className="password-reset-label"
                >
                  {i18n.t('repeatPass')}
                </label>
                <input
                  required
                  type="password"
                  id="new_password_repeat"
                  ref={(newPassRepeat) => (this.newPassRepeat = newPassRepeat)}
                  className="password-reset-input"
                />
              </div>
  
              <button type="submit" className="password-reset-btn">
                {i18n.t('confirm')}
              </button>
              <p>
                <a
                  href="mailto:juan.ayensa@certifica-t.app?subject=Support of Certifica-t (Change Password Problems)"
                  className="password-reset-link"
                >
                </a>
              </p>
            </form>
          </div>
          <Footer />
        </>
      );
    }
  }
}

export default withTranslation()(ChangePassword);
